var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconEarthHeart64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.155 54.5082C41.1441 54.5082 51.6738 43.9785 51.6738 30.9895C51.6738 18.0004 41.1441 7.4707 28.155 7.4707C15.1659 7.4707 4.63623 18.0004 4.63623 30.9895C4.63623 43.9785 15.1659 54.5082 28.155 54.5082Z",
    fill: "#D9D9D9",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2384_9530",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 50,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.155 54.5082C41.1441 54.5082 51.6738 43.9785 51.6738 30.9895C51.6738 18.0004 41.1441 7.4707 28.155 7.4707C15.1659 7.4707 4.63623 18.0004 4.63623 30.9895C4.63623 43.9785 15.1659 54.5082 28.155 54.5082Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.485
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2384_9530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.155 54.5082C41.1441 54.5082 51.6738 43.9785 51.6738 30.9895C51.6738 18.0004 41.1441 7.4707 28.155 7.4707C15.1659 7.4707 4.63623 18.0004 4.63623 30.9895C4.63623 43.9785 15.1659 54.5082 28.155 54.5082Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2475 6.26465C33.2475 6.26465 28.3533 9.07624 28.2671 13.3397C28.181 17.6032 33.7557 15.3121 33.7557 18.3908C33.7557 21.4696 30.1216 22.0377 26.8518 18.908C23.5819 15.7783 19.9592 15.4247 16.7116 18.2223C13.464 21.0201 12.9305 28.3808 18.524 29.5203C24.1176 30.6598 24.933 31.1038 24.933 36.7658C24.933 42.428 25.6695 43.6534 30.0543 43.6534C34.439 43.6534 32.0951 39.0737 33.7557 36.1073C35.4162 33.1408 38.2861 31.5925 38.2861 29.1808C38.2861 26.7689 32.7158 27.1859 33.7557 23.8191C34.7956 20.4524 39.7304 22.2773 42.1228 20.8709C44.5154 19.4645 46.1518 13.9372 45.4987 13.3397C45.1972 13.064 44.1185 11.5015 40.8101 9.48358C39.619 8.75709 38.7037 7.82574 37.2533 7.36185C35.5855 6.68993 33.2475 6.26465 33.2475 6.26465Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8516 59.6819L38.602 48.8954C36.3817 46.5589 36.2028 42.9503 38.1812 40.4057C40.402 37.5492 44.5244 37.0484 47.3645 39.2901L48.8516 40.4637L51.0299 38.9354C53.9467 36.889 57.972 37.6097 59.9977 40.5409C61.7253 43.0407 61.4634 46.4094 59.3702 48.6123L48.8516 59.6819Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconEarthHeart64);
export default __webpack_public_path__ + "static/media/pictogramBeaconEarthHeart64.be86fe89a61528b62fa9464da05d9294.svg";
export { ForwardRef as ReactComponent };